<template>
  <div>
    <div v-if="item?.name && item.show_title" :class="`${getTextClass(web_content_type)}`">
      {{ item.name }}
    </div>
    <CardSkeletons
      v-if="itemsPending"
      :count="3"
      :item-class="`${mock_web_content_type.break_pt}:${mock_web_content_type.width} p-2 col-12`"
    />
    <ScrollPanel v-else-if="attachments.length > 9" style="height: 450px !important">
      <div class="grid p-3 surface-100">
        <div
          v-for="attachment in attachments"
          :key="attachment.link ?? attachment.id"
          :class="`${mock_web_content_type.break_pt}:${mock_web_content_type.width} p-2 col-12`"
        >
          <NuxtLink
            :to="attachment?.link"
            class="block h-full no-underline text-color decoration-none"
          >
            <component
              :is="components[mock_web_content_type?.web_component]"
              :item="attachment"
              :web_content_type="mock_web_content_type"
            />
          </NuxtLink>
        </div>
      </div>
    </ScrollPanel>
    <div v-else class="grid p-3 surface-100">
      <div
        v-for="attachment in attachments"
        :key="attachment.link ?? attachment.id"
        :class="`${mock_web_content_type.break_pt}:${mock_web_content_type.width} p-2 col-12`"
      >
        <NuxtLink
          :to="attachment?.link"
          class="block h-full no-underline text-color decoration-none"
        >
          <component
            :is="components[mock_web_content_type?.web_component]"
            :item="attachment"
            :web_content_type="mock_web_content_type"
          />
        </NuxtLink>
      </div>
      <Links v-if="item?.web_links && item.web_links.length" :web_links="item.web_links" />
    </div>
  </div>
</template>

<script setup>
import { getTextClass, components } from '~/composables/useUtils'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  web_content_type: {
    type: Object,
    required: true,
  },
})

const { data: attachments, status: attachmentStatus } = await useAttachmentItems(
  () => props.item,
  { lazy: true }
)
const itemsPending = computed(() => ['idle', 'pending'].includes(attachmentStatus.value))

const mock_web_content_type = ref({
  width: 'col-4',
  break_pt: 'xl',
  web_component: 'Card',
  body_summary: true,
  img_width: 'cover',
  show_img: true,
  title_align: 'left',
  title_weight: 'semibold',
  title_size: 'lg',
  img_pos: 'top',
  height: 'full',
})
</script>

<style lang="scss" scoped>
a:link,
a:visited {
  // color: inherit !important;
  text-decoration: none !important;
}
.post_title {
  font-size: 28px;
}
.post_content {
  font-size: 22px;
}

.decoration-none:link,
.decoration-none:visited {
  text-decoration: none;
}

a:link:hover,
a:visited:active {
  text-decoration: underline;
}

i {
  color: $sats-green;
}
</style>
